import { render, staticRenderFns } from "./BnHelp.vue?vue&type=template&id=e2cd4384&scoped=true&"
import script from "./BnHelp.vue?vue&type=script&lang=js&"
export * from "./BnHelp.vue?vue&type=script&lang=js&"
import style0 from "./BnHelp.vue?vue&type=style&index=0&id=e2cd4384&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2cd4384",
  null
  
)

export default component.exports